"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var _1 = require("./");
/**
 * *******************************
 * Functions
 * *******************************
 */
function generateChartTicks(options, dataCount, stepIncrease) {
    var tickList = [];
    var currentStep = 0;
    for (var stepIndex = 0; stepIndex < options.maxNumberOfTicks; stepIndex++) {
        currentStep = stepIncrease * stepIndex;
        if (currentStep <= dataCount - 1) {
            tickList.push(options.getValueFn(options.data[currentStep]));
        }
    }
    if (currentStep < dataCount - 1) {
        tickList.push(options.getValueFn(options.data[dataCount - 1]));
    }
    return tickList;
}
/**
 * Returns first element in the collection or the default specified
 *
 * @export
 * @param {TElement[]} collection
 * @param {TElement} defaultResult
 * @returns {TElement}
 */
function firstOrDefault(collection, defaultResult) {
    if (defaultResult === void 0) { defaultResult = null; }
    return (collection || []).length === 0 ? defaultResult : collection[0];
}
exports.firstOrDefault = firstOrDefault;
/**
 * Determines if two arrays are equal
 *
 * @export
 * @param {any[]} left
 * @param {any[]} right
 * @returns {boolean}
 */
function isEqualArrays(left, right) {
    if (left.length !== right.length) {
        return false;
    }
    var index = left.length;
    while (index--) {
        var property = left[index];
        if (right.indexOf(property) === -1) {
            return false;
        }
        if (!_1.isEqual(left[property], right[property])) {
            return false;
        }
    }
}
exports.isEqualArrays = isEqualArrays;
/**
 * Will validate if the parameter is of type array and if it is empty
 *
 * @export
 * @param {any} array
 * @returns {boolean}
 */
function isArrayAndEmpty(array) {
    return !_1.isNullOrUndefined(array) && Array.isArray(array) && array.length === 0;
}
exports.isArrayAndEmpty = isArrayAndEmpty;
/**
* groupBy takes a collection and returns a dictionary grouping the collection by the key returned from the defined groupFn parameter.
*
* Optionally you can orchestrate the element that will be grouped, modifying the data structure while you are grouping, providing a performance benifit (lower the amount of loops on your dataset).
*
* @template TElement
* @param {TElement[]} collection
* @param {Function} groupFn
* @param {IGroupByOptions} [options]
* @returns {GroupedDictionary<TElement>}
*/
function groupBy(collection, groupFn, options) {
    var applyFirstResult = options && options.applyFirstElement;
    var result = {};
    for (var _i = 0, collection_1 = collection; _i < collection_1.length; _i++) {
        var element = collection_1[_i];
        var groupKey = groupFn(element);
        if (_1.isNullOrUndefined(groupKey)) {
            continue;
        }
        if (!result[groupKey]) {
            result[groupKey] = applyFirstResult ? null : [];
        }
        if ((applyFirstResult && result[groupKey] === null)) {
            result[groupKey] = options.elementOrchestrator ? options.elementOrchestrator(element) : element;
        }
        else if (!options || !options.applyFirstElement) {
            result[groupKey].push(options && options.elementOrchestrator ? options.elementOrchestrator(element) : element);
        }
    }
    return result;
}
exports.groupBy = groupBy;
/**
 * Will sort a collection by the provided key
 *
 * @export
 * @param {any[]} collection
 * @param {any} key
 * @param {SortDirection} [direction='ASC']
 * @returns {any[]}
 */
function sortBy(collection, key, direction) {
    if (direction === void 0) { direction = 'ASC'; }
    return collection.sort(function (a, b) {
        // supporting legacy code, key can be a string for accessing first layer properties.
        var aValue, bValue;
        if (typeof key === 'string') {
            aValue = a[key];
            bValue = b[key];
            // added support for using a getKeyFn to obtain the value for sorting.
        }
        else {
            aValue = key(a);
            bValue = key(b);
        }
        var isDesc = direction === "DESC";
        if (aValue < bValue) {
            return isDesc ? 1 : -1;
        }
        else if (aValue > bValue) {
            return isDesc ? -1 : 1;
        }
        else {
            return 0;
        }
    });
}
exports.sortBy = sortBy;
/**
 * Will sort a collection of elements by a defined list of elements
 *
 * @export
 * @param {any[]} arrayToSort
 * @param {any} sortList
 * @returns {any[]}
 */
function sortByMultiple(collection, sortList) {
    return collection.sort(function (a, b) {
        var objectList = [];
        for (var index in sortList) {
            // supporting legacy code, key can be a string for accessing first layer properties.
            var tmpA = void 0, tmpB = void 0;
            if (typeof sortList[index].name === "string") {
                tmpA = a[sortList[index].name];
                tmpB = b[sortList[index].name];
                // added support for using a getKeyFn to obtain the value for sorting.
            }
            else {
                tmpA = sortList[index].name(a);
                tmpB = sortList[index].name(b);
            }
            objectList.push({
                "test1": typeof tmpA === 'string' ? tmpA.toLowerCase() : tmpA,
                "test2": typeof tmpB === 'string' ? tmpB.toLowerCase() : tmpB,
                "direction": sortList[index].direction.toUpperCase() === 'DESC' ? -1 : 1
            });
        }
        for (var index in objectList) {
            var testGroup = objectList[index];
            if (testGroup.test1 < testGroup.test2) {
                return -1 * testGroup.direction;
            }
            if (testGroup.test1 > testGroup.test2) {
                return 1 * testGroup.direction;
            }
        }
        return 0;
    });
}
exports.sortByMultiple = sortByMultiple;
/**
 * Returns a unique value list of the one deminstional collection passed
 *
 * @export
 * @param {any[]} collection
 * @returns {any[]}
 */
function unique(collection) {
    var result = [];
    if (!_1.isNullOrEmpty(collection)) {
        var index = -1;
        var length = collection.length;
        startNextIteration: while (++index < length) {
            var value = collection[index];
            var existingIndex = result.length;
            while (existingIndex--) {
                if (_1.isEqual(result[existingIndex], value)) {
                    continue startNextIteration;
                }
            }
            result.push(value);
        }
    }
    return result;
}
exports.unique = unique;
/**
 * Returns a unique list of values based on the key passed, that is used to get the value from each object in the array
 *
 * @export
 * @param {any[]} collection
 * @param {string} [key=undefined]
 * @returns {any[]}
 */
function uniqueValueByKey(collection, key) {
    if (key === void 0) { key = undefined; }
    var result = [];
    var valueObjects = [];
    if (!_1.isNullOrEmpty(collection)) {
        for (var index = 0; index < collection.length; index++) {
            var record = collection[index];
            var valueIsObject = false;
            var value = void 0;
            // use record as value when no key is passed
            if (_1.isNullOrUndefined(key)) {
                if (_1.isObject(record)) {
                    // if record is an object we have to convert it to a string to ensure uniqueness works
                    value = JSON.stringify(record);
                    valueIsObject = true;
                }
                else {
                    value = record;
                }
            }
            else {
                value = record[key] || undefined;
            }
            if (value !== undefined && result.indexOf(value) < 0) {
                result.push(value);
                // track JSON string indexes
                if (valueIsObject) {
                    valueObjects.push(result.length - 1);
                }
            }
        }
    }
    // convert JSON strings back to objects
    if (!_1.isNullOrEmpty(valueObjects)) {
        for (var index = 0; index < valueObjects.length; index++) {
            result[index] = JSON.parse(result[index]);
        }
    }
    return result;
}
exports.uniqueValueByKey = uniqueValueByKey;
/**
 * Returns a unique list of values based on the function passed to obtain the value from each object in the array
 *
 * @export
 * @param {any[]} collection
 * @param {Function} valueFn
 * @returns {any[]}
 */
function uniqueValueByFn(collection, valueFn) {
    if (valueFn === void 0) { valueFn = undefined; }
    valueFn = valueFn || (function (record) { return record; });
    var valueObjectIndexes = [];
    var result = [];
    if (!_1.isNullOrEmpty(collection)) {
        for (var index = 0; index < collection.length; index++) {
            var record = collection[index];
            var value = valueFn(record);
            var valueIsObject = false;
            // track if values are objects, convert to string to ensure uniqueness works
            if (_1.isObject(value)) {
                value = JSON.stringify(value);
                valueIsObject = true;
            }
            if (value !== undefined && result.indexOf(value) < 0) {
                result.push(value);
                // keep track of string objects
                if (valueIsObject) {
                    valueObjectIndexes.push(result.length - 1);
                }
            }
        }
        // convert string objects back to JSON objeccts
        if (valueObjectIndexes.length > 0) {
            for (var index = 0; index < valueObjectIndexes.length; index++) {
                result[index] = JSON.parse(result[index]);
            }
        }
    }
    return result;
}
exports.uniqueValueByFn = uniqueValueByFn;
/**
 * Returns the latest record of a type
 *
 * @export
 * @param {any[]} list
 * @param {{}} options
 * @returns {any}
 */
function getLatestRecordOfType(list, options) {
    // GROUP array by type key value function passed
    if (list && options.getTypeValue) {
        var groupedList = groupBy(list, options.getTypeValue);
        // GET group we are interested in based on type key passed
        if (groupedList && options.getTypeKey) {
            var interestedGroup = groupedList[options.getTypeKey];
            // return the only record without having to sort it
            if (interestedGroup && interestedGroup.length === 1) {
                return interestedGroup[0];
                // sort the grouped data we have filtered out by the sort key passed (ASC)
            }
            else if (interestedGroup && options.getSortByKey) {
                var sortedRecords = sortBy(interestedGroup, options.getSortByKey);
                // return the latest record (the last record)
                if (sortedRecords && sortedRecords[sortedRecords.length - 1]) {
                    return sortedRecords[sortedRecords.length - 1];
                }
            }
        }
    }
    return false;
}
exports.getLatestRecordOfType = getLatestRecordOfType;
/**
 * Generates a list of chart axis ticks
 *
 * @export
 * @param {IChartTickOptions} options
 * @returns {any[]}
 */
function getSpacedChartTicks(options) {
    var tickList = [];
    if (options.data && options.data.length > 0 && options.maxNumberOfTicks > 0) {
        var dataCount = options.data.length;
        var stepIncrease = 0;
        if (dataCount <= options.maxNumberOfTicks) {
            stepIncrease = 1;
            options.maxNumberOfTicks = dataCount;
            tickList = generateChartTicks(options, dataCount, stepIncrease);
        }
        else {
            options.maxNumberOfTicks = options.maxNumberOfTicks - 1;
            stepIncrease = dataCount / options.maxNumberOfTicks;
            if (stepIncrease < Math.ceil(stepIncrease)) {
                tickList = getSpacedChartTicks(options);
            }
            else {
                tickList = generateChartTicks(options, dataCount, stepIncrease);
            }
        }
    }
    return tickList;
}
exports.getSpacedChartTicks = getSpacedChartTicks;
/**
 * Pushes unique elements into a given collection
 *
 * @export
 * @param {any[]} collection
 * @param {any} element
 * @param {Function} [getValidationValue=undefined]
 * @returns {any[]}
 */
function uniquePush(collection, element, getValidationValue) {
    if (getValidationValue) {
        var collectionFiltered = _1.safe(function () { return collection.filter(function (collectionElement) { return getValidationValue(collectionElement) === getValidationValue(element); }); }, []);
        if (collectionFiltered.length === 0) {
            collection.push(element);
        }
        collectionFiltered = undefined;
    }
    else {
        if (collection.indexOf(element) < 0) {
            collection.push(element);
        }
    }
    return collection;
}
exports.uniquePush = uniquePush;
//# sourceMappingURL=collection.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/@kurtosys/ksys_utils/dist/collection.js
// module id = 1435
// module chunks = 1